import { context, styled } from "../../util/style.js";

import { REVENUES_STEPS } from "./data.js";

const MAX_BAR_HEIGHT = 640;
const BAR_STEPS = [160, 320, 480, MAX_BAR_HEIGHT];

export function getBarHeight(revenue) {
  if (revenue <= REVENUES_STEPS[0]) {
    return (BAR_STEPS[0] * revenue) / REVENUES_STEPS[0];
  }
  if (revenue <= REVENUES_STEPS[1]) {
    return (
      BAR_STEPS[0] +
      ((BAR_STEPS[1] - BAR_STEPS[0]) * (revenue - REVENUES_STEPS[0])) /
        (REVENUES_STEPS[1] - REVENUES_STEPS[0])
    );
  }
  if (revenue <= REVENUES_STEPS[2]) {
    return (
      BAR_STEPS[1] +
      ((BAR_STEPS[2] - BAR_STEPS[1]) * (revenue - REVENUES_STEPS[1])) /
        (REVENUES_STEPS[2] - REVENUES_STEPS[1])
    );
  }
  return Math.min(
    MAX_BAR_HEIGHT,
    BAR_STEPS[2] +
      ((BAR_STEPS[3] - BAR_STEPS[2]) * (revenue - REVENUES_STEPS[2])) /
        (REVENUES_STEPS[3] - REVENUES_STEPS[2]),
  );
}

export default styled(function ({ revenue, className }) {
  const barHeight = getBarHeight(revenue);

  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 480 640"
      xmlSpace="preserve"
      className={className}
    >
      <g>
        <rect
          fill="#707070"
          stroke="#707070"
          strokeWidth="3"
          x="140"
          y="0"
          width="180"
          height={MAX_BAR_HEIGHT}
          rx="40"
          ry="40"
        />
        <rect
          fill={
            revenue <= REVENUES_STEPS[0]
              ? "#2e91d0"
              : revenue <= REVENUES_STEPS[1]
              ? "#1d70b7"
              : revenue <= REVENUES_STEPS[2]
              ? "#075895"
              : "#00427c"
          }
          x={140 + (40 - Math.min(barHeight / 2, 40))}
          y="0"
          width={180}
          height={Math.max(barHeight, 80)}
          rx={Math.min(barHeight / 2, 40)}
          ry={Math.min(barHeight / 2, 40)}
        />
      </g>

      <g>
        <text x="230" y="50" className="step-name" textAnchor="middle">
          PALIER 1
        </text>
        <text x="230" y="80" className="step-before" textAnchor="middle">
          1K€ DE CA
        </text>
        <text x="230" y="100" className="step-after" textAnchor="middle">
          = 1€ CADEAUX
        </text>
      </g>

      <g>
        <path
          className="circle"
          d="M70,180c-10.716,17.35-33.469,22.728-50.819,12.012-17.35-10.716-22.728-33.469-12.012-50.819,10.716-17.35,33.469-22.728,50.819-12.012,4.158,2.568,7.764,5.936,10.611,9.908"
        />
        <path
          fill="#2d2d2e"
          d="M86,149c3.095-.002,6.09,1.092,8.455,3.088l.993.84v-4.633l-.272-.179c-7.737-5.066-18.116-2.9-23.182,4.837-1.051,1.605-1.818,3.379-2.268,5.244h-5.057l-.9,2.413h5.56c-.044.5-.07,1-.07,1.508s.026,1.009.07,1.508h-3.056l-.9,2.413h4.349c2.171,8.99,11.218,14.519,20.208,12.348,1.864-.45,3.637-1.217,5.242-2.267l.272-.179v-4.634l-.993.84c-5.545,4.669-13.824,3.96-18.494-1.585-1.119-1.329-1.963-2.866-2.483-4.523h11.853l.9-2.413h-13.255c-.118-1.002-.118-2.013,0-3.015h14.375l.9-2.413h-14.769c1.717-5.472,6.787-9.197,12.522-9.2v.002Z"
        />
        <line stroke="#575257" x1="100" y1="160" x2="130" y2="160" />
        <text x="60" y="158" className="step-value" textAnchor="end">
          100K
        </text>
        <text x="60" y="176" className="step-label" textAnchor="end">
          CA
        </text>
      </g>

      <g>
        <g>
          <circle fill="#ffffff" cx="230" cy="160" r="30" />
          <path
            fill="#dac682"
            d="M237,160c-0.5,0.5-5.6420288,5.4160156-5.6420288,5.4160156c-0.4973755,0.5246582-1.3258667,0.546814-1.8505249,0.0494995c-0.0169678-0.0160522-0.0334473-0.0325928-0.0494995-0.0494995c0,0-5.190979-4.9199829-5.6420288-5.4160156c-0.5213013-0.5419922-0.5213013-1.3989868,0-1.940979c0.4671631-0.5246582,1.2711792-0.5712891,1.7958374-0.104187c0.0367432,0.0327148,0.0715332,0.0675049,0.104187,0.104187l4.6939697,4.5139771l4.6939697-4.5139771c0.4671631-0.5246582,1.2711792-0.5712891,1.7958374-0.104187c0.0367432,0.0327148,0.0715332,0.0675049,0.104187,0.104187C187.4050903z"
          />
        </g>
        <text x="230" y="210" className="step-name" textAnchor="middle">
          PALIER 2
        </text>
        <text x="230" y="240" className="step-before" textAnchor="middle">
          1K€ DE CA
        </text>
        <text x="230" y="260" className="step-after" textAnchor="middle">
          = 2€ CADEAUX
        </text>
      </g>

      <g>
        <path
          className="circle"
          d="M70,340c-10.716,17.35-33.469,22.728-50.819,12.012-17.35-10.716-22.728-33.469-12.012-50.819,10.716-17.35,33.469-22.728,50.819-12.012,4.158,2.568,7.764,5.936,10.611,9.908"
        />
        <path
          fill="#2d2d2e"
          d="M86,309c3.095-.002,6.09,1.092,8.455,3.088l.993.84v-4.633l-.272-.179c-7.737-5.066-18.116-2.9-23.182,4.837-1.051,1.605-1.818,3.379-2.268,5.244h-5.057l-.9,2.413h5.56c-.044.5-.07,1-.07,1.508s.026,1.009.07,1.508h-3.056l-.9,2.413h4.349c2.171,8.99,11.218,14.519,20.208,12.348,1.864-.45,3.637-1.217,5.242-2.267l.272-.179v-4.634l-.993.84c-5.545,4.669-13.824,3.96-18.494-1.585-1.119-1.329-1.963-2.866-2.483-4.523h11.853l.9-2.413h-13.255c-.118-1.002-.118-2.013,0-3.015h14.375l.9-2.413h-14.769c1.717-5.472,6.787-9.197,12.522-9.2v.002Z"
        />
        <line stroke="#575257" x1="100" y1="320" x2="130" y2="320" />
        <text x="60" y="318" className="step-value" textAnchor="end">
          250K
        </text>
        <text x="60" y="336" className="step-label" textAnchor="end">
          CA
        </text>
      </g>

      <g>
        <g>
          <circle fill="#ffffff" cx="230" cy="320" r="30" />
          <path
            fill="#dac682"
            d="M237,320c-0.5,0.5-5.6420288,5.4160156-5.6420288,5.4160156c-0.4973755,0.5246582-1.3258667,0.546814-1.8505249,0.0494995c-0.0169678-0.0160522-0.0334473-0.0325928-0.0494995-0.0494995c0,0-5.190979-4.9199829-5.6420288-5.4160156c-0.5213013-0.5419922-0.5213013-1.3989868,0-1.940979c0.4671631-0.5246582,1.2711792-0.5712891,1.7958374-0.104187c0.0367432,0.0327148,0.0715332,0.0675049,0.104187,0.104187l4.6939697,4.5139771l4.6939697-4.5139771c0.4671631-0.5246582,1.2711792-0.5712891,1.7958374-0.104187c0.0367432,0.0327148,0.0715332,0.0675049,0.104187,0.104187C187.4050903z"
          />
        </g>
        <text x="230" y="370" className="step-name" textAnchor="middle">
          PALIER 3
        </text>
        <text x="230" y="400" className="step-before" textAnchor="middle">
          1K€ DE CA
        </text>
        <text x="230" y="420" className="step-after" textAnchor="middle">
          = 3€ CADEAUX
        </text>
      </g>

      <g>
        <path
          className="circle"
          d="M70,500c-10.716,17.35-33.469,22.728-50.819,12.012-17.35-10.716-22.728-33.469-12.012-50.819,10.716-17.35,33.469-22.728,50.819-12.012,4.158,2.568,7.764,5.936,10.611,9.908"
        />
        <path
          fill="#2d2d2e"
          d="M86,469c3.095-.002,6.09,1.092,8.455,3.088l.993.84v-4.633l-.272-.179c-7.737-5.066-18.116-2.9-23.182,4.837-1.051,1.605-1.818,3.379-2.268,5.244h-5.057l-.9,2.413h5.56c-.044.5-.07,1-.07,1.508s.026,1.009.07,1.508h-3.056l-.9,2.413h4.349c2.171,8.99,11.218,14.519,20.208,12.348,1.864-.45,3.637-1.217,5.242-2.267l.272-.179v-4.634l-.993.84c-5.545,4.669-13.824,3.96-18.494-1.585-1.119-1.329-1.963-2.866-2.483-4.523h11.853l.9-2.413h-13.255c-.118-1.002-.118-2.013,0-3.015h14.375l.9-2.413h-14.769c1.717-5.472,6.787-9.197,12.522-9.2v.002Z"
        />
        <line stroke="#575257" x1="100" y1="480" x2="130" y2="480" />
        <text x="60" y="478" className="step-value" textAnchor="end">
          500K
        </text>
        <text x="60" y="496" className="step-label" textAnchor="end">
          CA
        </text>
      </g>

      <g>
        <g>
          <circle fill="#ffffff" cx="230" cy="480" r="30" />
          <path
            fill="#dac682"
            d="M237,480c-0.5,0.5-5.6420288,5.4160156-5.6420288,5.4160156c-0.4973755,0.5246582-1.3258667,0.546814-1.8505249,0.0494995c-0.0169678-0.0160522-0.0334473-0.0325928-0.0494995-0.0494995c0,0-5.190979-4.9199829-5.6420288-5.4160156c-0.5213013-0.5419922-0.5213013-1.3989868,0-1.940979c0.4671631-0.5246582,1.2711792-0.5712891,1.7958374-0.104187c0.0367432,0.0327148,0.0715332,0.0675049,0.104187,0.104187l4.6939697,4.5139771l4.6939697-4.5139771c0.4671631-0.5246582,1.2711792-0.5712891,1.7958374-0.104187c0.0367432,0.0327148,0.0715332,0.0675049,0.104187,0.104187C187.4050903z"
          />
        </g>
        <text x="230" y="530" className="step-name" textAnchor="middle">
          PALIER 4
        </text>
        <text x="230" y="560" className="step-before" textAnchor="middle">
          1K€ DE CA
        </text>
        <text x="230" y="580" className="step-after" textAnchor="middle">
          = 4€ CADEAUX
        </text>
      </g>
    </svg>
  );
})`
  display: none;
  ${context("for-tablet-landscape")`
    display: block;
    margin: 24px auto;
    max-width: 480px;
  `}

  .circle {
    stroke: #2d2d2e;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 4px;
    fill: transparent;
  }

  .step-value {
    fill: #0d97e2;
    font-weight: 700;
    font-size: 16px;
  }
  .step-label {
    fill: #0d97e2;
    font-weight: 700;
    font-size: 16px;
  }
  .step-name {
    fill: #add6ec;
    font-weight: 400;
    font-size: 14px;
  }
  .step-before {
    fill: #ffffff;
    font-weight: 400;
    font-size: 16px;
  }
  .step-after {
    fill: #ffffff;
    font-weight: 700;
    font-size: 16px;
  }
`;
